<template>
    <v-flex xs12>
      <v-card>
        <v-flex xs12 px-4 v-if="err">
          <v-alert :value="true" type="error">{{err}}</v-alert>
        </v-flex>
        <v-card-title class="pb-4 px-3 layout row wrap">
          <v-btn 
          class="primary ma-0" 
          @click='$router.push({ name: "discountCreate", params: { companyId: selectedCompany }})'
          :disabled="!selectedCompany">
            {{$lang.actions.createDiscount}}
          </v-btn>
          <v-checkbox
            color="primary"
            class="ml-3 mt-0"
            :label="$lang.labels.showActive"
            v-model="showActive"
            hide-details
           />
          <v-spacer />
          <v-autocomplete
            class="min-w max-w mx-2"
            :label="$lang.actions.selectCompany"
            :items="mappedCompanies"
            :loading="companyLoading"
            v-model="selectedCompany"
            hide-details
          />
          <v-text-field
            v-if="show"
            class="min-w max-w mx-2"
            v-model="search"
            append-icon="search"
            :label="$lang.labels.search"
            hide-details
          />
        </v-card-title>
        <v-data-table
          v-if='show'
          :headers="headers"
          :items="showActive ? activeDiscounts : allDiscounts"
          :search="search"
          :loading="loading"
          :rows-per-page-items="[50, 100, 250, 500, { text:'All' , value: -1 }]"
        >
          <v-progress-linear height="6" slot="progress" color="primary" indeterminate />
          <template slot="items" slot-scope="props">
            <td class="min-w">{{ props.item.ruleName }}</td>
            <td class="min-w">{{ formatDate(props.item.createdOn) }}</td>
            <td class="max-w">{{ props.item.status }}</td>
            <td class="min-w-lg">
              <v-btn class="primary mx-0 elevation-1" @click="$router.push({ name: 'discountEdit', params: { id: props.item.id } })">{{$lang.actions.edit}}</v-btn>
              <v-btn class="primary elevation-1" @click="changeStatus(props.item)">{{props.item.status === 'active' ? $lang.actions.deactivate : $lang.actions.activate}}</v-btn>
            </td>
          </template>
          <v-alert slot="no-results" :value="true" color="warning" icon="warning">
            Your search for "{{ search }}" found no results.
          </v-alert>
        </v-data-table>
      </v-card>
    </v-flex>
</template>

<script>
  import {DateTime} from 'luxon';

  export default {
    data() {
      return {
        err: '',
        search: '',
        show: false,
        loading: false,
        companyLoading: true,
        selectedCompany: '',
        companies: [],
        headers: [
          {text: this.$lang.labels.name, value: 'ruleName', align: 'left',},
          {text: this.$lang.labels.created, value: 'createdOn', align: 'left',},
          {text: this.$lang.labels.status, value: 'status', align: 'left',},
          {text: this.$lang.labels.actions, value: 'actions', align: 'left', sortable: false,},
        ],
        showActive: true,
        allDiscounts: [],
      };
    },
    computed: {
      activeDiscounts() {
        const discounts = this.allDiscounts;
        const activeDiscounts = [];
        for (let i=0; discounts.length > i; i++) {
          if (discounts[i].status === 'active') {
            activeDiscounts.push(discounts[i]);
          }
        }
        return activeDiscounts;
      },
      mappedCompanies() {
        return this.companies.map(company => ({
          text: `${company.name} (${company.companyStatus})`,
          value: company.id,
        }));
      },
    },
    methods: {
      formatDate(date) {
        return DateTime.fromISO(date).toFormat('yyyy-MM-dd HH:mm');
      },
      changeStatus(discount) {
        const action = discount.status === 'active' ? 'deactivate' : 'activate';
        this.$http.post(`discountrule/${action}/${discount.id}`)
        .then((res) => {
          if (res.body.status === 'Success') {
            this.$set(discount, 'status', action === 'activate' ? 'active' : 'inactive');
            return;
          }
          this.err = res.body.statusText;
        }, (err) => {
          this.err = err.body.statusText || err.body.message;
        });
      },
      fetchDiscountForCompany(id) {
        this.show = true;
        this.discountRules = [];
        this.loading = true;
        this.$http.post('discountrule/getall', { companyId: id })
          .then((res) => {
            this.loading = false;
            if (res.body.status === 'Success') {
              this.allDiscounts = res.body.discountRules;
              return;
            }
            if (this.discountRules.length === 0) {
              this.loading = false;
            }
            this.err = res.body.statusText;
          }, (err) => {
            this.loading = false;
            this.err = err.body.statusText || err.body.message;
          });
      },
    },
    watch: {
      err(val) {
        if (val !== '') {
          setTimeout(() => { this.err = ''; }, 5000);
        }
      },
      selectedCompany(val) {
        this.fetchDiscountForCompany(val);
        this.$cookie.set('companyedit', val, { expires: '8h' });
      },
    },
    created() {
      this.$http.get('company')
        .then((res) => {
          this.companyLoading = false;
          if (res.body.status === 'Success') {
            this.companies = res.body.companies;
            const edit = this.$cookie.get('companyedit');
            if (edit) this.selectedCompany = edit;
            return;
          }
          this.err = res.body.statusText;
        }, (err) => {
          this.companyLoading = false;
          this.err = err.body.statusText || err.body.message;
        });
    },
  };
</script>



// WEBPACK FOOTER //
// DiscountRules.vue?144f5a4a